<template>
  <div class="container-fluid pt-0 mt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <AddVehicle
      v-if="showModal"
      :show="showModal"
      :onCancel="closeModal"
      @showSuccessPopup="handleSuccessPopup"
    />

    <DeleteModal
      :show="showDelete"
      @submit="doDelete"
      @close="closeDelete"
      :name="$t('vehicle')"
    />

    <EditVehicle
      v-if="editVehicleModal"
      :show="editVehicleModal"
      :vehicle="editedVehicles"
      v-on:closeEditVehicleModal="editVehicleModal = false"
      @showSuccessPopup="handleSuccessPopup"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="successMsg"
      :heading="successHeading"
    />

    <div
      style="
          background-color: #fff;
          max-height: 40rem;
          overflow-y: auto;
          width: 100%;
          height: fit-content;
        "
    >
      <div class="card-body" style="overflow-x: auto; width: 100%">
        <div class="header d-flex justify-content-between align-items-center">
          <p>{{ $t("vehicles") }}</p>
          <TableSearch @handleSearch="handleSearch" />
        </div>

        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead style="background-color: rgba(240, 244, 251, 0.6)">
                  <tr>
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      @click="sortBy(column[1])"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span class="arrow"></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(vehicle, index) in paginatedData"
                    class="user-row"
                    style="border-bottom: unset"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                  >
                    <td>{{ vehicle.name }}</td>

                    <td>{{ vehicle.plateNumber }}</td>

                    <td>{{ vehicle.type }}</td>

                    <td style="display:flex; align-items: center; gap: 8px;">
                      <div :class="{'circle': true, 'assigned': isVehicleAssigned(vehicle), 'unassigned': !isVehicleAssigned(vehicle)}"></div>
                      <span v-if="isVehicleAssigned(vehicle)">{{$t("assigned")}}</span>
                      <span v-else>{{$t("unassigned")}}</span>
                    </td>

                    <td>
                      <div class="d-flex align-items-center col-gap-1">
                        <span
                          class="cursor-pointer"
                          @click="editvehicle(vehicle)"
                        >
                          <IconEdit />
                        </span>
                        <span
                          class="cursor-pointer"
                          @click="openDelete(vehicle.id)"
                        >
                          <IconDelete />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageCount="pageCount"
              :data="paginatedData"
              :sizeperpage="sizeperpage"
              :pageNumber="pageNumber"
              :pages="pages"
              @goToLastPage="goToLastPage"
              @nextPage="nextPage"
              @handlePageChange="handlePageChange"
              @goToFirstPage="goToFirstPage"
              @prevPage="prevPage"
              @onchange="onchange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "intro.js/introjs.css";

import AddVehicle from "../../views/Modals/AddVehicle.vue";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import IconEdit from "../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import DeleteModal from "../Modals/DeleteModal.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import EditVehicle from "../Modals/EditVehicle.vue";

export default {
  name: "DispatchPartners",
  mixins: [tableMixin],
  components: {
    AddVehicle,
    Pagination,
    TableSearch,
    IconEdit,
    IconDelete,
    DeleteModal,
    Loading,
    SuccessModal,
    EditVehicle,
  },
  props: {
    showModal: Boolean,
    closeModal: Function,
  },
  data() {
    return {
      showDelete: false,
      sortOrders: {},

      dataTable: [],

      isLoading: true,

      fullPage: true,

      showSuccessPopup: false,

      editVehicleModal: false,

      editedVehicles: [],

      successMsg: "",
      successHeading: "",
    };
  },
  mounted() {
    this.fetchVehicles(this.params);
  },
  computed: {
    ...mapGetters(["vehicles", "meta", "drivers"]),

    paginationMeta() {
      return this.meta;
    },
    tableColumns() {
      return [
        [this.$t("name"), "fullname"],
        [this.$t("plate_number"), "email"],
        [this.$t("type"), "phonenumber"],
        [this.$t("status"), "status"],
        [this.$t("action"), "column2"],
      ];
    },
  },
  methods: {
    ...mapActions([
      "getVehicles",
      "addVehicles",
      "editVehicle",
      "deleteVehicle",
    ]),
    isVehicleAssigned(vehicle) {
      return this.drivers.some(driver => driver.assignedVehicleData && driver.assignedVehicleData.id === vehicle.id);
    },

    handleSuccessPopup({ msg, heading }) {
      this.successMsg = msg;
      this.successHeading = heading;
      this.showSuccessPopup = true;
    },

    closeDelete() {
      this.showDelete = false;
    },
    doDelete() {
      this.isLoading = true;
      this.deleteVehicle(this.id).then(() => {
        this.getVehicles();
        this.isLoading = false;
        this.showDelete = false;

        this.showSuccessPopup = true;

        this.successMsg = this.$t("deleted_vehicle_mssg");
        this.successHeading = this.$t("deleted_vehicle_heading");
      });
    },
    openDelete(id) {
      this.showDelete = true;
      this.id = id;
    },
    editvehicle(vehicleInfo) {
      this.editedVehicles = [vehicleInfo];
      this.editVehicleModal = true;
    },
    doSearch() {
      let params = {
        ...this.params,
        name: this.searchQuery,
      };
      this.fetchVehicles(params);
    },
    fetchVehicles(params) {
      this.isLoading = true;
      this.getVehicles(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    vehicles: {
      handler: function() {
        this.dataTable = this.vehicles;
      },
      deep: true,
    },
    params() {
      this.fetchVehicles(this.params);
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 1rem;
}

.header > p {
  font-size: 14px;
  font-weight: 700;
  line-height: 18.2px;
  color: rgba(64, 74, 87, 1);
  margin-top: 1rem;
}

.circle {
  height: 10px;
  width: 10px;
  border-radius: 100%;
}

.circle.assigned {
  background-color: rgba(40, 168, 74, 1);
}

.circle.unassigned {
  background-color: rgba(235, 87, 87, 1); 
}

</style>
